import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "email-logo",
  "use": "email-logo-usage",
  "viewBox": "0 0 30 23",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 23\" id=\"email-logo\"><path clip-rule=\"evenodd\" d=\"M1 2.833a1.5 1.5 0 011.5-1.5h25a1.5 1.5 0 011.5 1.5v17a1.5 1.5 0 01-1.5 1.5h-25a1.5 1.5 0 01-1.5-1.5v-17z\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M28.548 2.067l-10.859 8.352a4.41 4.41 0 01-5.378 0L1.452 2.067\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/email-logo.svg
// module id = GTVX
// module chunks = 39 44